import { Input, Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute,RouterLink} from '@angular/router';
import { Router } from '@angular/router';
import { EventBean } from '../../../beansts/Event';
import {AppDataService} from "../../../services/app-data.service";
import {InstagramUserBean} from "../../../beansts/instagram.user.bean";
import {FormBuilder, FormGroup} from "@angular/forms";
import {CompanyService} from "../../../services/company.service";
import { TranslationService } from '../../../services/translation.service';
declare let $: any;
declare var Swal : any;
declare var JitsiMeetExternalAPI;

@Component({
    selector : 'checkvideo',
    templateUrl:'checkvideo-component.html',
})
export class CheckVideoComponent implements OnInit, OnDestroy{


  public room;
  public event;
  public meetroom
  public src;
  public audioSelect;
  public videoSelect;

  public stream;
  public video;
  public closed=false;
  public api;
  public roomlink

  public phoneOK=true
  public videoOK=true
  public audioOK=true
  public logged=false

  public constructor( public _router : Router,public translate: TranslationService,public _routeParams : ActivatedRoute,public _appData : AppDataService,private fb : FormBuilder, private _companyService : CompanyService) {
  }


    public ngOnInit(): any {

      $('#main').css('height:100vh')
      this._appData.page='welcome'
      let user=null;
      if (typeof window !== "undefined" && localStorage) {
        user=localStorage.getItem('instagramUser');
      }
      if (user=="undefined"){
        user=null;
      }
      if (user){
        this._appData.instagramUser=JSON.parse(user);
        this.logged=true;
      //update user for vippoints
        this._companyService.getUserByUid(this._appData.instagramUser.uid).then((val)=>{
          let us=val.data();
          this._appData.instagramUser=us;                        
          if (localStorage) {localStorage.setItem('instagramUser',JSON.stringify(this._appData.instagramUser))}
        });
        if (this._appData.instagramUser.shouldResetPassword){
          Swal.fire({title:'Você precisa resetar sua senha.',text:"Estamos enviando um email para que você atualize sua senha. Não deixe de atualizá-la"}).then(
            v=>{
              this._companyService.forgetPassword(this._appData.instagramUser.email).then((val)=>{
                this._appData.instagramUser.shouldResetPassword=false;
                this._companyService.updateUserProperty('shouldResetPassword',false,this._appData.instagramUser)
                Swal.fire(this.translate.instant('GAME_USERLOGIN_COMPONENT_12'))
              }).catch(err=>{
                Swal.fire(this.translate.instant('GAME_USERLOGIN_COMPONENT_13'))
              }     
                );
              console.log('a')
            }
          )
        }

      }
    
      if (window){
        var ua = navigator.userAgent.toLowerCase();
        var isAndroid = ua.indexOf("android") > -1; //&& ua.indexOf("mobile");
        if(isAndroid) {
          // Do something!
          // Redirect to Android-site?
          this._appData.android=true;
        }else{
        }
      }
      this.initWorld()

      let querySelector=null
      if (this.api){  
        this.api.dispose();
      }
      if (!this.roomlink){//abrindo por conta propria
            //estou numa videoconferencia da pista
            let date=new Date();
            let milis=date.getTime();
            this.roomlink='test_camera_'+milis
          //}
      }


      return true;

    }

    public gotoLiveplanet(){
      let domain=window.location.origin
      window.location.replace(domain+"/gameevent/1592880902713?room="+this._appData.room.id);   

  //    let full=document.getElementById('welcomeBody')
    //  full.remove();
/*          this._router.navigate(['gameevent/1592880902713'], {
              queryParams: { room: this._appData.room.id }
          });*/
//      let frame=document.getElementById('mygame')
  //    frame.style.visibility='visible'
/*
      if (!this.errorCamera){
        Swal.fire({title:this.translate.instant("CHECKVIDEO_COMPONENT_20"),
        text:this.translate.instant("CHECKVIDEO_COMPONENT_21"),
        confirmButtonText: this.translate.instant("YES"),
        cancelButtonText:this.translate.instant("NO"),
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false, 
        }).then((result) => {
          if (result.dismiss=='backdrop') {}
          else if (result.dismiss=='close') {}
          else if (result.dismiss=='cancel'){}
          else{
            let full=document.getElementById('welcomeBody')
            full.remove();
      
            let frame=document.getElementById('mygame')
            frame.style.visibility='visible'
        }})
      }
      else if (!this.errorAudio){
        Swal.fire({title:this.translate.instant("CHECKVIDEO_COMPONENT_22"),
        text:this.translate.instant("CHECKVIDEO_COMPONENT_23"),
        confirmButtonText: this.translate.instant("ENTER"),
        cancelButtonText:this.translate.instant("NO"),
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false, 
        }).then((result) => {
          if (result.dismiss=='backdrop') {}
          else if (result.dismiss=='close') {}
          else if (result.dismiss=='cancel'){}
          else{
            let full=document.getElementById('welcomeBody')
            full.remove();
      
            let frame=document.getElementById('mygame')
            frame.style.visibility='visible'
        }})

      }
      else if (!this.errorPhone){
        Swal.fire({title:this.translate.instant("CHECKVIDEO_COMPONENT_24"),
        text:this.translate.instant("CHECKVIDEO_COMPONENT_25"),
        confirmButtonText: this.translate.instant("ENTER"),
        cancelButtonText:this.translate.instant("NO"),
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false, 
        }).then((result) => {
          if (result.dismiss=='backdrop') {}
          else if (result.dismiss=='close') {}
          else if (result.dismiss=='cancel'){}
          else{
            let full=document.getElementById('welcomeBody')
            full.remove();
      
            let frame=document.getElementById('mygame')
            frame.style.visibility='visible'
        }})
      }
      else if (!this._appData.instagramUser){
        Swal.fire({title:this.translate.instant("CHECKVIDEO_COMPONENT_26"),
        text:this.translate.instant("CHECKVIDEO_COMPONENT_27"),
        confirmButtonText: this.translate.instant("ENTER"),
        cancelButtonText:this.translate.instant("NO"),
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false, 
        }).then((result) => {
          if (result.dismiss=='backdrop') {}
          else if (result.dismiss=='close') {}
          else if (result.dismiss=='cancel'){}
          else{
            let full=document.getElementById('welcomeBody')
            full.remove();
      
            let frame=document.getElementById('mygame')
            frame.style.visibility='visible'
          

          }})
      }
      else {

            let domain=window.location.origin
            let full=document.getElementById('welcomeBody')
            full.remove();
      
            let frame=document.getElementById('mygame')
            frame.style.visibility='visible'
      
      }*/
    }
    public initWorld(){
      this._routeParams.queryParams.subscribe(params => {
        this.event = params['event'];
        this.room=params['room']
        this.meetroom=params['meet']
        let querySelector=document.querySelector('#meet')
        if (!this.event) this.event=1592880902713
        if (!this.room) this.room="1601478396713"


        this._companyService.getRoom(this.room).get().then(v=>{
          let room=v.data();         
          this._appData.room=v.data()   

/*          let iframe=document.getElementById("mygame")
          iframe['src']="https://liveplanet.com.br/gameevent/"+this.event+'?room='+this.room*/
          if (this._appData.room.openingVideo){
            let videoSrc=document.getElementById("videoSrc")
            videoSrc['src']=this._appData.room.openingVideo

          }


        })
        this._companyService.getEventById(this.event).subscribe(
          (_event: any) => {
              var obj = _event;
              let event;
              if (obj.url){
                obj=_event.json();
              }
              if (obj.length>0){
                event=obj[0]
              }
              else{
                event=obj;
              }
              let myevent:EventBean = event;
              this._appData.event=myevent;
          });


      });
    }
    public errorCamera(){
      let iframe=this.api.getIFrame();
      let obj={hax:"jitsi",command:"openVideoSettings",user:''}
      iframe.contentWindow.postMessage(JSON.stringify(obj), "https://" + "viplistas.com.br/");		   
    }
    public errorAudio(){
      let iframe=this.api.getIFrame();
      let obj={hax:"jitsi",command:"openSettings",user:''}
      iframe.contentWindow.postMessage(JSON.stringify(obj), "https://" + "viplistas.com.br/");		   
    }
    public errorPhone(){
      let iframe=this.api.getIFrame();
      let obj={hax:"jitsi",command:"openSettings",user:''}
      iframe.contentWindow.postMessage(JSON.stringify(obj), "https://" + "viplistas.com.br/");		   
    }

    public openAvatar(){
      let link='https://liveplanet.com.br/avatar?uid='+this._appData.instagramUser.uid+'&room='+this._appData.room.id+'&cid='+this._appData.room.company
      location.replace(link);

      $('#dresserModal').modal({backdrop: 'static', keyboard: false})
      $('#dresserModal').modal('show')
      $('#dresserModalClick').click()  
    }
    public openRegister(){
      $('#registerSocialModal').modal('show'); 
      this._appData.tiping=true;
    }
    public refresh(){
      let iframe=this.api.getIFrame();
      let obj={hax:"jitsi",command:"openSettings",user:''}
      iframe.contentWindow.postMessage(JSON.stringify(obj), "https://" + "viplistas.com.br/");		
    }

    public close(){
      $('#checkVideoModal').modal('hide');
    }

    public gotDevices(deviceInfos) {
      for (let i = 0; i !== deviceInfos.length; ++i) {
        const deviceInfo = deviceInfos[i];
        const option = document.createElement("option");
        option.value = deviceInfo.deviceId;
        if (deviceInfo.kind === "audioinput") {
          option.text =
            deviceInfo.label || "microphone " + (this.audioSelect.length + 1);
          this.audioSelect.appendChild(option);
        } else if (deviceInfo.kind === "videoinput") {
          option.text = deviceInfo.label || "camera " + (this.videoSelect.length + 1);
          this.videoSelect.appendChild(option);
        } else {
          console.log("Found another kind of device: ", deviceInfo);
        }
      }
    }

    public getStream() {
      if (this.stream) {
        this.stream.getTracks().forEach(function (track) {
          track.stop();
        });
      }
    
      const constraints = {
        audio: {
          deviceId: { exact: this.audioSelect.value },
        },
        video: {
          deviceId: { exact: this.videoSelect.value },
        },
      };
    
      navigator.mediaDevices
        .getUserMedia(constraints)
        .then(this.gotStream)
        .catch(this.handleError);
    }
    
    public gotStream(stream) {
      this.stream = stream; // make stream available to console
      this.video['srcObject'] = stream;
    }
    
    public handleError(error) {
      console.error("Error: ", error);
    }

    public ngOnDestroy() : any {
    }

}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+easylogin/checkvideo/checkvideo-component.ts